import MainClass, { MAIN_CLASS_PARAMS } from "@scriptFe/utils/mainClass.ts";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import gsap from 'gsap';



class MastheadHome extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	splitText(){
		let heading = this.selector.querySelector('.raise-masthead-heading')
		let description = this.selector.querySelector('.raise-masthead-description')

		const headingSplit = new Splitting({ target: heading, by: 'lines' });
		const desSplit = new Splitting({ target: description, by: 'lines' });
		return {
			heading:headingSplit,
			description:desSplit
		}
	}

	init () {
		const SplitData = this.splitText()
		const ELEMENT_DECOR = {
			VIOLET_DECOR: this.selector.querySelector('#violetDecor') as HTMLElement || null,
			ORANGE_DECOR: this.selector.querySelector('#orangeDecor') as HTMLElement || null
		}

		const ELEMENT = {
			VIOLET: this.selector.querySelector('#violet') as HTMLElement || null,
			ORANGE: this.selector.querySelector('#orange') as HTMLElement || null,
			SAND: this.selector.querySelector('#sand') as HTMLElement || null,
			AMBER: this.selector.querySelector('#amber') as HTMLElement || null
		}

		const ELEMENT_DECOR_PATH = {
			ORANGE_DECOR_SMALL:ELEMENT_DECOR.ORANGE_DECOR?.querySelector('#circleSmall') as HTMLElement || null,
			ORANGE_DECOR_BIG:ELEMENT_DECOR.ORANGE_DECOR?.querySelector('#circleBig') as HTMLElement || null,
			ROUND_DECOR_TOP:ELEMENT.ORANGE?.querySelector('#decor-top')  as HTMLElement || null,
			ROUND_DECOR_BOT:ELEMENT.ORANGE?.querySelector('#decor-bot')  as HTMLElement || null
		}

		const ELEMENT_CONTENT = {
			VIOLET: Array.prototype.slice.call(ELEMENT.VIOLET?.querySelectorAll('.raise-heading')) as HTMLElement[],
			SAND: Array.prototype.slice.call(ELEMENT.SAND?.querySelectorAll('.raise-heading')) as HTMLElement[],
			ORANGE: Array.prototype.slice.call(ELEMENT.ORANGE?.querySelectorAll('.raise-heading')) as HTMLElement[],
		}
		const IMAGE_ELEMENT = {
			VIOLET: ELEMENT.VIOLET?.querySelector('.raise-image-people') as HTMLElement || null,
			SAND:ELEMENT.SAND?.querySelector('.raise-image-people') as HTMLElement || null
		}
		const FIRST_STATE = 1,SECOND_STATE = 2, THIRD_STATE = 3;
		const DECOR_INIT_STYLE = {
			VIOLET_SCALE:3.4,
			SAND_SCALE:0
		};
		const TIMELINE_ANIMATION = gsap.timeline()

		//Init State Element Animation
		ELEMENT_DECOR.VIOLET_DECOR && gsap.set(ELEMENT_DECOR.VIOLET_DECOR,{scale:DECOR_INIT_STYLE.VIOLET_SCALE})
		ELEMENT_DECOR_PATH.ORANGE_DECOR_SMALL && gsap.set(ELEMENT_DECOR_PATH.ORANGE_DECOR_SMALL,{rotate:'90deg',y:'-50%',x:0,opacity:0})
		ELEMENT_DECOR_PATH.ORANGE_DECOR_BIG && gsap.set(ELEMENT_DECOR_PATH.ORANGE_DECOR_BIG,{rotate:'270deg',y:"-50%",opacity:0})
		ELEMENT_CONTENT.SAND && gsap.set(ELEMENT_CONTENT.SAND,{y:'50px',opacity:0})
		ELEMENT_CONTENT.ORANGE && gsap.set(ELEMENT_CONTENT.ORANGE,{y:'50px',opacity:0})
		ELEMENT_CONTENT.VIOLET && gsap.set(ELEMENT_CONTENT.VIOLET,{y:'50px',opacity:0})
		IMAGE_ELEMENT.VIOLET && gsap.set(IMAGE_ELEMENT.VIOLET,{opacity:0, x:'-100%'})
		IMAGE_ELEMENT.SAND && gsap.set(IMAGE_ELEMENT.SAND,{opacity:0, x:'100%'})
		ELEMENT_DECOR_PATH.ROUND_DECOR_BOT && gsap.set(ELEMENT_DECOR_PATH.ROUND_DECOR_BOT,{opacity:0,xPercent:-100})
		ELEMENT_DECOR_PATH.ROUND_DECOR_TOP && gsap.set(ELEMENT_DECOR_PATH.ROUND_DECOR_TOP,{opacity:0,xPercent:100})

		//Animation Stage 1
		TIMELINE_ANIMATION.fromTo([ELEMENT.VIOLET] as HTMLElement[],{
			width: '50%',
			opacity: 0
		},{
			opacity:1,
			width:'100%',
			duration:.5,
			ease: "power1.inOut",
			stagger:0.1
		},FIRST_STATE)
		TIMELINE_ANIMATION.fromTo([ELEMENT.SAND] as HTMLElement[],{
			opacity: 0
		},{
			ease: "power1.inOut",
			duration:.5,
			opacity:1,
		},FIRST_STATE)
		if(SplitData.heading){
			SplitData.heading[0].lines && (SplitData.heading[0].lines.forEach((line,index) => {
				TIMELINE_ANIMATION.fromTo(line as HTMLElement[],{
					x:'-100px',
					opacity: 0
				},{
					opacity:1,
					x:0,
					duration:.325,
					ease: "power1.inOut",
					delay:index*0.15
				},FIRST_STATE)
			}))
		}
		//Animation Stage 2
		TIMELINE_ANIMATION.fromTo([ELEMENT.AMBER] as HTMLElement[],{
			height: '25%',
			opacity:0,
		},{
			opacity:1,
			height:'100%',
			duration:.6,
			ease: "none"
		},SECOND_STATE)
		TIMELINE_ANIMATION.fromTo([ELEMENT.ORANGE] as HTMLElement[],{
			height: '0%',
		},{
			height:'100%',
			duration:.6,
			ease: "none"
		},SECOND_STATE)
		TIMELINE_ANIMATION.to([IMAGE_ELEMENT.VIOLET,IMAGE_ELEMENT.SAND],{
			x:0,
			opacity:1,
			duration:.5,
			ease: "power1.inOut"
		},SECOND_STATE)
		TIMELINE_ANIMATION.to([ELEMENT_DECOR.VIOLET_DECOR],{
			scale:1,
			duration:.5,
			ease: "power1.inOut"
		},SECOND_STATE)

		//Animation Stage 3
		TIMELINE_ANIMATION.to([ELEMENT_DECOR_PATH.ORANGE_DECOR_SMALL],{
			opacity:1,
			rotate:0,
			duration:.5,
			ease: "power1.inOut"
		},THIRD_STATE)
		TIMELINE_ANIMATION.to([ELEMENT_DECOR_PATH.ORANGE_DECOR_BIG],{
			opacity:1,
			rotate:360,
			// yPercent: -50,
			y:'-50%',
			duration:.5,
			ease: "power1.inOut"
		},THIRD_STATE)
		TIMELINE_ANIMATION.to([ELEMENT_DECOR_PATH.ROUND_DECOR_BOT],{
			opacity:1,
			xPercent: 0,
			duration:.5,
			ease: "power1.inOut"
		},THIRD_STATE)
		TIMELINE_ANIMATION.to([ELEMENT_DECOR_PATH.ROUND_DECOR_TOP],{
			opacity:1,
			xPercent: 0,
			duration:.5,
			ease: "power1.inOut"
		},THIRD_STATE)
		TIMELINE_ANIMATION.to(ELEMENT_CONTENT.SAND,{
			opacity:1,
			y:0,
			duration:.5,
			ease: "power1.inOut",
			stagger:0.1
		},THIRD_STATE)
		TIMELINE_ANIMATION.to(ELEMENT_CONTENT.ORANGE,{
			opacity:1,
			y:0,
			duration:.5,
			ease: "power1.inOut",
			stagger:0.1
		},THIRD_STATE)
		TIMELINE_ANIMATION.to(ELEMENT_CONTENT.VIOLET,{
			y:0,
			opacity:1,
			stagger:0.1
		},THIRD_STATE)
		if(SplitData.description){
			SplitData.description[0].lines && (SplitData.description[0].lines.forEach((line,index) => {
				TIMELINE_ANIMATION.fromTo(line as HTMLElement[],{
					paddingBottom:'24px',
					y:'24px',
					opacity: 0
				},{
					y:0,
					opacity:1,
					paddingBottom:0,
					duration:.325,
					ease: "power1.inOut",
					// delay:index*0.1
				},THIRD_STATE)
			}))
		}

	}
}

export default MastheadHome;
